<template>
  <div class="container">
    <div class="ui grid">
      <h1>Import</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form segment" @submit.prevent="importFile">
      <div class="ui grid stackable">
        <div class="row">
          <div class="sixteen wide column">
            <div v-if="success" class="ui visible success message">
              <i class="close icon" @click="success = false"></i>
              <div class="header">Import was successful.</div>
              <p>The machine imported successfully.</p>
            </div>
            <div class="ui visible warning message">
              <div class="header">Warning</div>
              File must be a CSV and not an Excel file.
            </div>
            <label for="file"
              >File
              <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
              />
            </label>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">Upload</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

export default {
  name: "Import",
  computed: {},
  components: {},
  data() {
    return {
      file: [],
      error: false,
      success: false,
    };
  },
  mounted() {},
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    importSuccessful() {
      this.$refs.file.value = '';
      this.success = true;
    },
    importFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    importFile() {
      let formData = new FormData();
      formData.append("file", this.file);

      apiService
        .importFile(formData)
        .then(() => {
          this.importSuccessful();
        })
        .catch((err) => this.importFailed(err));
    },
  },
};
</script>

<style module></style>
